/* eslint-disable max-len */
import React, { useContext,useEffect } from 'react'
import GlobalContext from '../../../../components/Context/GloablContext';
import { setPatientSearch,resetPatientSearch } from '../../../../redux/patientSearchSlice';
import AdvancedSearchInputBox from '../../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import DateInputStatic from '../../../../components/DateField/staticdate';
import { useSelector,useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export default function PatiantAdvancedSearch({handleOnSubmit,emptyField,setEmptyField,orgCorpAndMonitorSearch,orgPatientSearch}) {
    const patientSearch = useSelector(state => state.patientSearchData);
    const searchApplied = useSelector((state) => state.patientSearchData.patsearchApplied);
    const {isSideBar,setIsSideBar,isSearchOpen,setIsSearchOpen} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()
    const dispatch = useDispatch()

    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)

    
    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;
        // Allow only numeric input for the "age" field
        if (id === 'age') {
        // Use a regular expression to allow only numbers
            updatedValue = updatedValue.replace(/\D/g, ''); // Removes any non-numeric characters
        }


        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue;
        }
    
        const updatedState = { ...patientSearch, [id]: updatedValue };
    
        // Handle special cases for username and email
        if (['user_name', 'user_name_domain'].includes(id)) {
            const isUserNameEmpty = updatedState.user_name === '' && updatedState.user_name_domain === '';
            if (isUserNameEmpty) updatedState.user_name_inverse = '';
        }
        if (['email_address', 'email_address_domain'].includes(id)) {
            const isEmailEmpty = updatedState.email_address === '' && updatedState.email_address_domain === '';
            if (isEmailEmpty) updatedState.email_address_inverse = '';
        }

        // General case for other fields
        if (updatedValue === '' && updatedState[`${id}_inverse`] === 'true') {
            updatedState[`${id}_inverse`] = '';
        }
    
        // Update the patientSearch state and dispatch to Redux
        setPatientSearch(updatedState);
        dispatch(setPatientSearch(updatedState));
    };
    
    //handleSelect checkbox functions
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;
    
        // Create an updated patientSearch state
        let updatedState = { ...patientSearch };
    
        if (field === 'active' || field === 'inactive') {
            // Update the status array if it's a status-related checkbox
            const updatedStatus = checked 
                ? [...(patientSearch.status || []), field] 
                : (patientSearch.status || []).filter((status) => status !== field);
    
            // Uncheck status_inverse if the status array is empty
            if (updatedStatus.length === 0) {
                updatedState.status_inverse = '';
            }
    
            updatedState.status = updatedStatus;
        } else {
            // Handle other fields as boolean values
            updatedState[field] = checked ? 'true' : '';
        }
    
        // Dispatch the updated state
        dispatch(setPatientSearch(updatedState));
    };
    
    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsSearchOpen(!isSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {
            dispatch(resetPatientSearch());
        }
    };

    const isApplyButtonDisabled = () => {
        return Object.entries(patientSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetPatientSearch());
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)

    };

    const handleDateChange = (newDate) => {
        setEmptyField(false);

        const validatedpurchaseDay = /^[0-9]*$/.test(newDate.day) && 
                                     (newDate.day.includes('-') || (newDate.day.length <= 2 && parseInt(newDate.day) <= 31)) 
            ? newDate.day 
            : '';
    
        const validatedpurchaseMonth = /^[0-9]*$/.test(newDate.month) && 
                                       (newDate.month.includes('-') || (newDate.month.length <= 2 && parseInt(newDate.month) <= 12)) 
            ? newDate.month 
            : '';
    
        const validatedpurchaseYear = /^[0-9]*$/.test(newDate.year) && 
                                      (newDate.year.includes('-') || newDate.year.length <= 4) 
            ? newDate.year 
            : '';
    
        const isDateCleared = !validatedpurchaseDay.trim() && !validatedpurchaseMonth.trim() && !validatedpurchaseYear.trim();
    
        dispatch(setPatientSearch({
            ...patientSearch,
            dob_day: validatedpurchaseDay,
            dob_month: validatedpurchaseMonth,
            dob_year: validatedpurchaseYear,
            dob_inverse: isDateCleared ? '' : patientSearch.dob_inverse,
        }));
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    useEffect(() => {
            
        const params = Object.fromEntries(searchParams);
           
        if (params.search) {
            // Decode the search string to get individual fields
            const searchDecoded = decodeURIComponent(params.search);
           
            // Existing matches for patient_id, first_name, last_name and other states
            const idMatch = searchDecoded.match(/(patient_id|user_id)=(ne:)?(.+?)(;|$)/);
            const firstNameMatch = searchDecoded.match(/(first_name|userDetails\.first_name)=(ne:)?(.+?)(;|$)/);
            const lastNameMatch = searchDecoded.match(/(last_name|userDetails\.last_name)=(ne:)?(.+?)(;|$)/);
            const middleNameMatch = searchDecoded.match(/middle_name=(ne:)?(.+?)(;|$)/);
            const ageMatch = searchDecoded.match(/patient_dynamic_age=(ne:)?(.+?)(;|$)/);
            const subDivisionMatch = searchDecoded.match(/subdivision_name=(ne:)?(.+?)(;|$)/);
            const primaryIdenMatch = searchDecoded.match(/primary_identifier=(ne:)?(.+?)(;|$)/);
            const secondaryIdenMatch = searchDecoded.match(/secondary_identifier=(ne:)?(.+?)(;|$)/);
            const userNameMatch = searchDecoded.match(/user_name=(ne:)?(.+?)(;|$)/);
            const emailMatch = searchDecoded.match(/email_address=(ne:)?(.+?)(;|$)/);
            const statusMatches = searchDecoded.match(/(status|userDetails\.status)=(ne:)?([^;]+)/g);
            const dobMatch = searchDecoded.match(/date_of_birth=(ne:)?([^;]+)/g);
           
            // Build the new state
            const updatedState = {};
            
            if (statusMatches) {
                // Map through the matches and process the statuses
                updatedState.status = statusMatches.map((match) => {
                    // Match again to extract `ne:` and the value
                    const [, , isInverse, statusValue] = match.match(/(status|userDetails\.status)=(ne:)?(.+)/) || [];
                    return statusValue === '__NULL__' ? '-' : decodeURIComponent(statusValue);
                });
            
                // Determine if any status has an inverse condition (`ne:`)
                updatedState.status_inverse = statusMatches.some((match) => 
                    match.includes("=ne:")
                ) ? 'true' : '';
            }
            
            if (dobMatch) {
                // Map through the matches and process the statuses
                const dobValues = dobMatch.map((match) => {
                    const [, isInverse, dobValue] = match.match(/date_of_birth=(ne:)?(.+)/) || [];
                    return dobValue === '__NULL__' ? '-' : decodeURIComponent(dobValue);
                });

                // Determine if any status has an inverse condition (`ne:`)
                updatedState.dob_inverse = dobMatch.some((match) => match.startsWith("date_of_birth=ne:")) ? 'true' : '';

                const [year, month, day] = dobValues[0].split('-');
                updatedState.dob_day = day;
                updatedState.dob_month = month;
                updatedState.dob_year = year;

            }
            
            // Handle user_name field
            if (userNameMatch) {
                const isInverse = !!userNameMatch[1]; // Check if 'ne:' prefix is present
                const userNameValue = userNameMatch[2]; // Extract the user_name value after 'ne:'
                const [namePart, domainPart] = userNameValue.split('@');
        
                updatedState.user_name = namePart === '__NULL__' ? '-' : namePart || ''; // Before '@' part
                updatedState.user_name_domain = domainPart === '__NULL__' ? '-' : domainPart || ''; // After '@' part
                updatedState.user_name_inverse = isInverse ? 'true' : ''; // Inverse checkbox
            }
    
            // Handle email_address field
            if (emailMatch) {
                const isInverse = !!emailMatch[1]; // Check if 'ne:' prefix is present
                const emailValue = emailMatch[2]; // Extract the email_address value after 'ne:'
                const [namePart, domainPart] = emailValue.split('@');
    
                updatedState.email_address = namePart === '__NULL__' ? '-' : namePart || ''; // Before '@' part
                updatedState.email_address_domain = domainPart === '__NULL__' ? '-' : domainPart || ''; // After '@' part
                updatedState.email_address_inverse = isInverse ? 'true' : ''; // Inverse checkbox
            }
           
            // handle user_id or patient_id field
            
            if (idMatch) {
                const isInverse = !!idMatch[2]; // Check if 'ne:' prefix is present
                const idValue = idMatch[3]; // Extract the value after 'ne:'

                // Always update `user_id` and `user_id_inverse`
                updatedState.user_id = idValue === '__NULL__' ? '-' : idValue;
                updatedState.user_id_inverse = isInverse ? 'true' : '';
            }

                    
            // Handle first_name field
            if (firstNameMatch) {
                const isInverse = !!firstNameMatch[2]; // Check if `ne:` is present
                const firstNameValue = firstNameMatch[3]; // Extract the actual value
                updatedState.first_name = firstNameValue === '__NULL__' ? '-' : firstNameValue;
                updatedState.first_name_inverse = isInverse ? 'true' : '';
            }

            // Handle last_name field
            if (lastNameMatch) {
                const isInverse = !!lastNameMatch[2]; // Check if `ne:` is present
                const lastNameValue = lastNameMatch[3]; // Extract the actual value
                updatedState.last_name = lastNameValue === '__NULL__' ? '-' : lastNameValue;
                updatedState.last_name_inverse = isInverse ? 'true' : '';
            }


            // Handle last_name field
            if (middleNameMatch) {
                const isInverse = !!middleNameMatch[1];
                const middleNameValue = middleNameMatch[2];
                updatedState.middle_name = middleNameValue === '__NULL__' ? '-' : middleNameValue;
                updatedState.middle_name_inverse = isInverse ? 'true' : '';
            }
            

            // Handle last_name field
            if (ageMatch) {
                const isInverse = !!ageMatch[1];
                const ageValue = ageMatch[2];
                updatedState.age = ageValue === '__NULL__' ? '-' : ageValue;
                updatedState.age_inverse = isInverse ? 'true' : '';
            }
    
            // Handle sub_division_name field
            if (subDivisionMatch) {
                const isInverse = !!subDivisionMatch[1];
                const subDivisionValue = subDivisionMatch[2];
                updatedState.sub_division_name = subDivisionValue === '__NULL__' ? '-' : subDivisionValue;
                updatedState.sub_division_name_inverse = isInverse ? 'true' : '';
            }

            // Handle primary_identifier field
            if (primaryIdenMatch) {
                const isInverse = !!primaryIdenMatch[1];
                const primaryIdenValue = primaryIdenMatch[2];
                updatedState.primary_identifier = primaryIdenValue === '__NULL__' ? '-' : primaryIdenValue;
                updatedState.primary_identifier_inverse = isInverse ? 'true' : '';
            }

            // Handle secondary_identifier field
            if (secondaryIdenMatch) {
                const isInverse = !!secondaryIdenMatch[1];
                const primaryIdenValue = secondaryIdenMatch[2];
                updatedState.secondary_identifier = primaryIdenValue === '__NULL__' ? '-' : primaryIdenValue;
                updatedState.secondary_identifier_inverse = isInverse ? 'true' : '';
            }

                    
            // Handle search_mode if applicable
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or' ? true : false;
            }
           
            // Dispatch the action to update Redux state
            dispatch(setPatientSearch(updatedState));
        }
    }, [isSearchOpen]);


    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => handleOnSubmit(e)} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={patientSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${patientSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!patientSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!patientSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"ID"}
                                    placeholder={"Enter ID"}
                                    id={"user_id"}
                                    data_testid={"user_id"}
                                    htmlFor={"user_id"}
                                    value={patientSearch.user_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={15}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_id_inverse')}
                                        checked={patientSearch.user_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={patientSearch?.user_id?.trim()===""}
                                    />
                                    <label htmlFor='user_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Username</p>
                                <div className='w-full flex items-center'>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"example"}
                                        id={"user_name"}
                                        data_testid={"user_name"}
                                        htmlFor={"user_name"}
                                        value={patientSearch?.user_name}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                    <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"domain"}
                                        id={"user_name_domain"}
                                        data_testid={"user_name_domain"}
                                        htmlFor={"user_name_domain"}
                                        value={patientSearch.user_name_domain}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_name_inverse')}
                                        checked={patientSearch.user_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={patientSearch?.user_name_domain?.trim()===""&&patientSearch?.user_name?.trim()===""}
                                    />
                                    <label htmlFor='user_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"First Name"}
                                    placeholder={"Enter first name"}
                                    id={"first_name"}
                                    data_testid={"first_name"}
                                    htmlFor={"first_name"}
                                    value={patientSearch?.first_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='first_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'first_name_inverse')}
                                        checked={patientSearch?.first_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={patientSearch?.first_name?.trim()===""}
                                    />
                                    <label htmlFor='first_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {!orgCorpAndMonitorSearch&&
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Middle Name"}
                                    placeholder={"Enter middle name"}
                                    id={"middle_name"}
                                    data_testid={"middle_name"}
                                    htmlFor={"middle_name"}
                                    value={patientSearch?.middle_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='middle_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'middle_name_inverse')}
                                        checked={patientSearch?.middle_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={patientSearch?.middle_name?.trim()===""}
                                    />
                                    <label htmlFor='middle_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        }
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Last Name"}
                                    placeholder={"Enter last name"}
                                    id={"last_name"}
                                    data_testid={"last_name"}
                                    htmlFor={"last_name"}
                                    value={patientSearch?.last_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='last_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'last_name_inverse')}
                                        checked={patientSearch?.last_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={patientSearch?.last_name?.trim()===""}
                                    />
                                    <label htmlFor='last_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {!orgCorpAndMonitorSearch&&!orgPatientSearch&&<>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <DateInputStatic
                                        labeltext={'Date of Birth'}
                                        date={{
                                            day: patientSearch.dob_day,
                                            month: patientSearch.dob_month,
                                            year: patientSearch.dob_year,
                                        }}
                                        onDateChange={handleDateChange}
                                        patientDob={true}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='dob_inverse'
                                            onChange={(e) => handleCheckboxChange(e, 'dob_inverse')}
                                            checked={patientSearch.dob_inverse === 'true'}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            disabled={
                                                patientSearch?.dob_day?.length !== 2 ||
                                        patientSearch?.dob_month?.length !== 2 ||
                                        patientSearch?.dob_year?.length !== 4 ||
                                        patientSearch?.dob_day?.trim() === "" ||
                                        patientSearch?.dob_month?.trim() === "" ||
                                        patientSearch?.dob_year?.trim() === ""
                                            }
                                        />
                                        <label htmlFor='dob_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <AdvancedSearchInputBox
                                        label={"Age"}
                                        placeholder={"Enter age"}
                                        id={"age"}
                                        data_testid={"age"}
                                        htmlFor={"age"}
                                        value={patientSearch?.age}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={3}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='age_inverse'
                                            onChange={(e) => handleCheckboxChange(e, 'age_inverse')}
                                            checked={patientSearch?.age_inverse === 'true'}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            disabled={patientSearch?.age?.trim()===""}
                                        />
                                        <label htmlFor='age_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>}
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Status</p>
                                <div className='flex items-center'>
                                    <div className='p-[8px] flex items-center checkboxFocusAllignment mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='active'
                                            onChange={(e) => handleCheckboxChange(e, 'active')}
                                            checked={patientSearch?.status?.includes('active')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='active' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            Active
                                        </label>
                                    </div>
                                    <div className='p-[8px] ml-[20px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='inactive'
                                            onChange={(e) => handleCheckboxChange(e, 'inactive')}
                                            checked={patientSearch?.status?.includes('inactive')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='inactive' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            Inactive
                                        </label>
                                    </div>
                                </div>


                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='status_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'status_inverse')}
                                        checked={patientSearch?.status_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={patientSearch?.status?.length === 0}
                                    />
                                    <label htmlFor='status_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {!orgCorpAndMonitorSearch&&!orgPatientSearch&&<>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <AdvancedSearchInputBox
                                        label={"Sub Division Name"}
                                        placeholder={"Enter sub division name"}
                                        id={"sub_division_name"}
                                        data_testid={"sub_division_name"}
                                        htmlFor={"sub_division_name"}
                                        value={patientSearch?.sub_division_name}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='sub_division_name_inverse'
                                            onChange={(e) => handleCheckboxChange(e, 'sub_division_name_inverse')}
                                            checked={patientSearch?.sub_division_name_inverse === 'true'}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            disabled={patientSearch?.sub_division_name?.trim()===""}
                                        />
                                        <label htmlFor='sub_division_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <AdvancedSearchInputBox
                                        label={"Primary Identifier"}
                                        placeholder={"Enter primary identifier"}
                                        id={"primary_identifier"}
                                        data_testid={"primary_identifier"}
                                        htmlFor={"primary_identifier"}
                                        value={patientSearch?.primary_identifier}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='primary_identifier_inverse'
                                            onChange={(e) => handleCheckboxChange(e, 'primary_identifier_inverse')}
                                            checked={patientSearch?.primary_identifier_inverse === 'true'}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            disabled={patientSearch?.primary_identifier?.trim()===""}
                                        />
                                        <label htmlFor='primary_identifier_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <AdvancedSearchInputBox
                                        label={"Secondary Identifier"}
                                        placeholder={"Enter secondary identifier"}
                                        id={"secondary_identifier"}
                                        data_testid={"secondary_identifier"}
                                        htmlFor={"secondary_identifier"}
                                        value={patientSearch?.secondary_identifier}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='secondary_identifier_inverse'
                                            onChange={(e) => handleCheckboxChange(e, 'secondary_identifier_inverse')}
                                            checked={patientSearch?.secondary_identifier_inverse === 'true'}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            disabled={patientSearch?.secondary_identifier?.trim()===""}
                                        />
                                        <label htmlFor='secondary_identifier_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Email Address</p>
                                    <div className='w-full flex items-center'>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={"example"}
                                            id={"email_address"}
                                            data_testid={"email_address"}
                                            htmlFor={"email_address"}
                                            value={patientSearch?.email_address}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={60}
                                        />
                                        <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={"domain"}
                                            id={"email_address_domain"}
                                            data_testid={"email_address_domain"}
                                            htmlFor={"email_address_domain"}
                                            value={patientSearch?.email_address_domain}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={60}
                                        />
                                    </div>
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='email_address_inverse'
                                            onChange={(e) => handleCheckboxChange(e, 'email_address_inverse')}
                                            checked={patientSearch?.email_address_inverse === 'true'}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            disabled={patientSearch?.email_address?.trim()===""&&patientSearch?.email_address_domain.trim()===""}
                                        />
                                        <label htmlFor='email_address_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>}
                    
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
